import { TablePropertiesConstants } from '../table-properties.constant';
import { ViewDetails } from '../../models/view-details.model';
import { RequestsTypesConstants } from '../requests-side-menu.constants';

export class ticketingConstants {
    public static TICKETING_REQUESTS: ViewDetails = {
        ...RequestsTypesConstants.INPROGRESS_REQUESTS,
        tableColumn: TablePropertiesConstants.TICKETING_TABLE_COLUMNS,
        tableWithSelection: false
    };

 
}
